import { cn } from "@/utils/css";
import Icon from "@/components/library/Icon";
import type { ISidebarLink } from "@/types/layout/navigation";

interface ISideBarItem {
  collapseSidebar: boolean;
  selected: string;
  item: ISidebarLink;
}

const SideBarItem: React.FC<ISideBarItem> = ({
  collapseSidebar,
  selected,
  item,
}) => (
  <div
    className={cn(
      "flex w-full cursor-pointer items-center space-x-4 rounded-xl px-4 text-lg hover:bg-gray-700 md:text-base",
      collapseSidebar
        ? "mb-2 py-3 md:mb-3 md:justify-center md:py-4"
        : "mb-4 py-3",
      selected === item.id ? "bg-dines-green hover:bg-dines-green " : ""
    )}
  >
    {item.icon && (
      <Icon
        icon={item.icon}
        size="lg"
        className={cn(
          selected === item.id
            ? "text-dines-purple-darkest"
            : "text-dines-green"
        )}
      />
    )}
    <span
      className={cn(
        selected === item.id
          ? "font-bold text-dines-purple-darkest "
          : "text-white",
        collapseSidebar ? "md:hidden" : "flex"
      )}
    >
      {item.name}
    </span>
  </div>
);

export default SideBarItem;
